// extracted by mini-css-extract-plugin
export default {"mySkills":"style_mySkills__WUbDr","loading":"style_loading__PMhK6"};